module.exports = __webpack_public_path__ + "media/CN_005.aae13956.mp3";